import { render } from "./main-page.vue?vue&type=template&id=032aaa62"
import script from "./main-page.vue?vue&type=script&lang=js"
export * from "./main-page.vue?vue&type=script&lang=js"

import "./main-page.vue?vue&type=style&index=0&id=032aaa62&lang=scss"

import exportComponent from "/Users/connoringold/Documents/projects/bao/toteme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__